import Vue from 'vue';
import VueRouter from 'vue-router';
import { VueMaskDirective } from 'v-mask';
import NavLogin from '@/components/NavLogin';
import PopupLayout from '@/components/PopupLayout';
import ContactForm from '@/components/ContactForm';
import store from '@/store';
import '@/validator';
import router from '@/router';

Vue.use(VueRouter);
Vue.directive('mask', VueMaskDirective);

const helpers = {
	auth: NavLogin,
	popup: PopupLayout,
	'contact-form': ContactForm,
};

const instances = {};

Object.keys(helpers).forEach(key => {
	if (document.getElementById(key) !== null) {
		Object.assign(instances, { 
			[key]: new Vue({
				el: `#${key}`,
				render: h => h(helpers[key]),
				store,
				router,
			})
		})
	}
});

export default instances;